module.exports = __webpack_public_path__ + "img/bottomMa1.1cf50abc.png";